import styled from 'styled-components';
import { speed } from 'src/ui/common/config/animations';
import { LazyLoadMedia } from 'src/ui/common/organisms/lazy-load-media';

export const StyledLazyLoadImage = styled(LazyLoadMedia)`
  & img {
    transition: transform ${speed.content} ease-in;
  }

  &:hover img {
    transform: scale(1.1, 1.1);
  }
`;

export const StyledVideoWrapper = styled.div`
  position: relative;
  padding-bottom: 100%;
  height: 0;
    
  & > div {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
    
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform ${speed.content} ease-in;
    
    &:hover {
      transform: scale(1.1, 1.1);
    }
  }
`;